"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_mail__read__empty__state__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ebebeb;}.cls-2{opacity:0.12;}.cls-2,.cls-4,.cls-6{isolation:isolate;}.cls-3{fill:#fff;}.cls-4{opacity:0.06;}.cls-5{fill:none;}.cls-6{opacity:0.2;fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 54.29,
    y1: 166.06,
    x2: 137.71,
    y2: 82.64,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 192.93)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "mail-read-empty-state-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "ea7fb327-afd6-49b9-9352-5b48db3851a1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a331d80a-f8e1-4595-bdc7-e97f97c3317c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "aa01a99f-eb22-4e8d-95eb-fd7b734f433b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d0a4dffd-aa06-4831-9dcc-7fb8efe06f2c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b8e29293-af93-46ef-9e1b-acdd8d0d5128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "d028a684-fee7-4f2a-83e2-01aa1542c2e6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,72l68,42s5.83,4,12,4,12-4,12-4l68-42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M96,116c-6.17,0-12-4-12-4L16,70v2l68,42s5.83,4,12,4,12-4,12-4l68-42V70l-68,42S102.17,116,96,116Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M96,118c-6.17,0-12-4-12-4L16,72v80a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16V72l-68,42S102.17,118,96,118Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160,166H32a16,16,0,0,1-16-16v2a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-2A16,16,0,0,1,160,166Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16,72H176V68.46a8,8,0,0,0-3.8-6.81L108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66a8,8,0,0,0-3.8,6.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16,72H176V68.46a8,8,0,0,0-3.8-6.81L108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66a8,8,0,0,0-3.8,6.8Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16,72l68,42s5.83,4,12,4,12-4,12-4l68-42",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M172.2,61.66,108,21.5s-5.83-4-12-4-12,4-12,4L19.8,61.66a8,8,0,0,0-3.8,6.8V72l68,42s5.83,4,12,4,12-4,12-4l68-42V68.46A8,8,0,0,0,172.2,61.66Z",
    transform: "translate(0 0)"
  }))))))));
}

var _default = ic_mail__read__empty__state__dark;
exports.default = _default;